import React from 'react';
import '../Chennels.css';
function ChennelsScreen() {
    return (
        <div className="main-container">

            <h2>Channels</h2>
            <div className="image-container">
            
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1119/661119-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1132/661132-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1121/661121-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1137/661137-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1122/661122-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1111/661111-h" alt="chennel-icon" className="chennel"/>
            
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1103/661103-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1130/661130-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1138/661138-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1105/661105-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1117/661117-h" alt="chennel-icon" className="chennel"/>
            
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1116/661116-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1100/661100-h" alt="chennel-icon" className="chennel"/>
            <img src="https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/1133/661133-h" alt="chennel-icon" className="chennel"/>

            </div>
        </div>
    )
}

export default ChennelsScreen
